export const MIN_BOUGHT_AMOUNT = 999;
